<!--
 * @Description: 自然人、园区个体、委托代开通用上传
 * @Date: 2024-05-14 10:22:16
-->
<template>
  <div class="part-3">
    <div
      style="margin-top:2px;text-align: left;"
      v-if="fileListArr.length == 0 && pageStatus == 2"
    >
      无附件
    </div>
    <div
      class="list"
      :class="{
        'hide-btn': pageStatus == 2,
        disabled: fileListArr.length >= limit
      }"
    >
      <el-upload
        class="files-upload"
        ref="uploadRef"
        multiple
        with-credentials
        :headers="headers"
        :action="fileUpload"
        :accept="FILE_TYPE"
        :limit="limit"
        :file-list="fileListArr"
        :disabled="pageStatus == 2"
        :auto-upload="false"
        :before-upload="beforeUpload"
        :on-change="debounce(handleChange)"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :on-error="handleError"
        :on-preview="clickFile"
        :on-exceed="handleExceed"
      >
        <div
          class="add-file"
          @click.stop="() => {}"
          v-if="fileListArr.length >= limit"
        >
          <el-button
            :disabled="fileListArr.length >= limit"
            style="margin-left:5px;display:block;"
            size="small"
            type="primary"
          >
            选择文件
          </el-button>
        </div>
        <div class="add-file" v-else>
          <el-button
            style="margin-left:5px;display:block;"
            size="small"
            type="primary"
          >
            添加文件
          </el-button>
        </div>
        <div slot="tip" class="el-upload__tip">
          仅支持格式：{{ fileTypeText }}，最大支持{{ maxSize }}M
        </div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import { taxPayment } from '@/api/ajax';
import { getToken } from '@/tools/auth';
import Config from '@/config/index';
import { debounce } from '@/tools';

const getLastStr = str => {
  const match = str.match(/.*\.([^.]*)$/);
  return match ? match[1] : '';
};

export default {
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pageStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      debounce,
      FILE_TYPE: '.pdf,.jpg,.png,.rar,.zip,.7z,.xls,.xlsx',
      fileListArr: [],
      fileUpload: taxPayment.person.fileUploadTaxPaymentAnnex,
      // fileUpload,
      limit: 100,
      maxSize: 20,
      headers: {
        [Config.token]: getToken()
      }
    };
  },
  computed: {
    fileTypeText() {
      return this.FILE_TYPE.replace(/\./g, '').replace(/,/g, '、');
    }
  },
  methods: {
    beforeUpload(file) {
      const name = file.name.toLowerCase();
      const type = getLastStr(name);
      if (!~this.FILE_TYPE.indexOf(type)) {
        this.$message.error(`仅支持格式：${this.fileTypeText}，最大支持10兆。`);
        return false;
      }
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message.error(`上传文件大小不得超过${this.maxSize}M`);
        return false;
      }
    },
    handleExceed() {
      this.$message.error(
        `上传文件数量不超过${this.limit}个,还可添加${this.limit -
          this.fileListArr.length}个文件`
      );
    },
    handleError() {
      this.$emit('on-error');
    },
    handleChange(file, fileList) {
      if (file.status === 'ready') {
        // const name = file.name.toLowerCase();
        // const type = getLastStr(name);
        // if (!~this.FILE_TYPE.indexOf(type)) {
        //   this.fileListArr = [...this.fileListArr]; // 重置数组，让UI响应一次
        //   this.$message.error(
        //     `仅支持格式：${this.fileTypeText}，最大支持${this.maxSize}兆。`
        //   );
        //   return false;
        // }
        // if (file.size > this.maxSize * 1024 * 1024) {
        //   this.fileListArr = [...this.fileListArr];
        //   this.$message.error(`上传文件大小不得超过${this.maxSize}M`);
        //   return false;
        // }
        this.fileListArr = fileList;
        this.$refs.uploadRef.submit();
      }
    },
    handleSuccess(response, file, fileList) {
      const arr = [];
      const allUpload = fileList.every(item => {
        const { data, status, message } = item.response || {};
        const { fileUrl } =
          Object.prototype.toString.call(data) == '[object Object]' ? data : {};
        arr.push({
          ajaxMessage: message,
          ajaxStatus: status,
          name: item.name,
          url: fileUrl || item.url
        });
        return item.response || item.status == 'success';
      });
      if (allUpload) {
        this.$emit(
          'success',
          arr.map(item => {
            return {
              name: item.name,
              url: item.url
            };
          })
        );
      }
    },
    handleRemove(file, fileList) {
      // status标识上传成功，只处理手动删除
      if (file.status === 'success') {
        this.$emit('success', fileList);
      }
    },
    clickFile(file) {
      if (this.pageStatus == 2) {
        this.$downloadFile(file.name, file.url);
      }
    }
  },
  mounted() {
    this.fileListArr = [...this.fileList];
  },
  watch: {
    fileList: {
      handler: function(newV) {
        this.fileListArr = [...(newV || [])];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.part-3 {
  .list {
    // &.disabled {
    //   .add-file {
    //     display: none;
    //   }
    // }
    &.hide-btn {
      margin-top: -40px;
      .add-file {
        display: none;
      }
    }
  }
}
.files-upload {
  text-align: left;
}
</style>
